module.exports = __webpack_public_path__ + "images/goal-getter-6d7a54e1d37dd29ff57c608338e2d911.png";